import { Component } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { AuthenticationService } from '@core/services/authentication.serivce';
import { BaseDetailForm } from '@shared/ui/base-detail-form';
import { AuthUser } from '@shared/interfaces/entities/auth-user.interface';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { TextControl } from '@shared/ui/controls/text-control.model';
import { ToggleControl } from '@shared/ui/controls/toggle-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { UploadControl } from '../../../shared/ui/controls/upload-control.model';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faRemove } from '@fortawesome/free-solid-svg-icons';
import { DetailService } from '../../../core/services/detail.service';
import { UiColumn } from '../../../shared/ui/ui-column';
import { TabOptions } from '../../../shared/interfaces/tab-option.interface';
import { TabControl } from '../../../shared/ui/controls/tab-control.model';
import { Collection } from '../../../shared/interfaces/entities/collection.interface';
import { SelectEvent, FileInfo, RemoveEvent } from '@progress/kendo-angular-upload';
import { ImageInfo } from '../../../shared/components/upload/upload.component';
import { SecurityRole } from '../../../shared/literals/shared.literal';
import { TextAreaControl } from '../../../shared/ui/controls/textarea-control.model';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-security-role',
    templateUrl: './security-role.component.html',
    styleUrls: ['./security-role.component.css'],
    standalone: false
})

export class SecurityRoleComponent extends BaseDetailForm<SecurityRole> {

  id: string;
  constructor(private router: ActivatedRoute, private auth: AuthenticationService, private detailService: DetailService<any>) {
    super();
    this.name = "Security Role";
    this.apiController = "SecurityRole";
    this.keyFieldName = "id";

    this.router.params.subscribe(params => this.id = params['id']);

    this.initializeUiControls();
  }


  ngOnInit() {
    var session = this.auth.getSession();
  }

  public removeCollection() {
    //This is the collection organization ID 
    this.detailService.remove(this.id, "Collection");
  }

  preSave(formControls: { [k: string]: FormControl }): void {
    var organizationId = this.auth.getOrganizationId();
    formControls['organizationId'] = new FormControl(organizationId);
  }

  override initializeUiControls() {

    const detailsView = new ViewControl("Security Role Details");

    const userDetails = new UiGroupControl("", "Security Role Details");

    const name = new TextControl("name", "Name", "");
    const description = new TextAreaControl("description", "Description", "");
    const disabled = new ToggleControl("isActive", "Is Active?", null);

    var uRow1 = new ViewRowControl();
    uRow1.controls.push(name, disabled);

    var uRow2 = new ViewRowControl();
    uRow2.controls.push(description);

    userDetails.rows.push(uRow1, uRow2);
    detailsView.controls.push(userDetails);

    //Security Role Organizations
    var securityRoleOrganizationColumns: UiColumn[] = [
      new UiColumn("organization_Name", "Organization", 300),
      new UiColumn("clientAdminCanEdit", "Client Admin Can Edit", 300)
    ];

    var securityRoleOrganizationOptions: TabOptions = {
      name: "securityRoleOrganizations",
      label: "Security Role Organizations",
      columns: securityRoleOrganizationColumns,
      apiController: "SecurityRoleOrganization",
      showDeleteBtn: true,
      showEditBtn: true,
      editWindowSettings:
      {
        width: 500,
        height: 300
      }
    };

    const securityRoleOrganizationTab = new TabControl(securityRoleOrganizationOptions);

    //Security Role Permissions
    var securityRolePermissionColumns: UiColumn[] = [
      new UiColumn("securityPermission_Name", "Permission", 300)
    ];

    var securityRolePermissionOptions: TabOptions = {
      name: "securityRolePermissions",
      label: "Security Role Permissions",
      columns: securityRolePermissionColumns,
      apiController: "SecurityRolePermission",
      showDeleteBtn: true,
      editWindowSettings: {
        width: 600,
        height: 200
      },
    };

    const securityRolePermissionTab = new TabControl(securityRolePermissionOptions);

    //If this is a new security role - hide the partial view, we can only add the organizations and permissions IF there is a security role saved
    if (Number(this.id) != 0) {
      detailsView.controls.push(securityRoleOrganizationTab, securityRolePermissionTab);
    }

    this.views.push(detailsView);

    var session = this.auth.getSession();
    var canEditSettings: boolean = false;
    if (session) {
      canEditSettings = session.userId.toString() == this.id;
    }
  }
}


